var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgDeleteDocument = function SvgDeleteDocument(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0.862549C4.47 0.862549 0 5.33255 0 10.8625C0 16.3925 4.47 20.8625 10 20.8625C15.53 20.8625 20 16.3925 20 10.8625C20 5.33255 15.53 0.862549 10 0.862549ZM15 14.4525L13.59 15.8625L10 12.2725L6.41 15.8625L5 14.4525L8.59 10.8625L5 7.27255L6.41 5.86255L10 9.45255L13.59 5.86255L15 7.27255L11.41 10.8625L15 14.4525Z",
    fill: "#DB1E1E"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDeleteDocument);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "delete-document.d432d8626da508659eb396d71dd61dc0.svg";